<template>
  <v-app id="mainPageStandardImage" class="mainPage">
    <v-content>
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-form
          ref="form"
          on-submit="return false;"
          autocomplete="on"
          @submit.prevent="handleSubmit(submit)"
        >
          <div>
            <div class="welcome-container lili-flex justify-center">
              <div
                v-if="isTopContent"
                class="welcome-content lili-container lili-flex column align-center"
              >
                <TopContent
                  :is-go-back="true"
                  @callSubmit="handleSubmit(submit)"
                />
                <div class="lili-divider"></div>
              </div>
            </div>
            <div class="dataSection">
              <div class="dataContent">
                <v-container>
                  <v-layout justify-center>
                    <v-flex xs8 align-center>
                      <div v-if="!noTitle" class="progress-bubble-text">
                        {{ progressText }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
                <slot name="data"></slot>
              </div>
            </div>
          </div>
        </v-form>
        <div v-if="$store.state.timeout">
          <div class="user-msg-container lili-flex align-center justify-center">
            <div class="user-msg-conent lili-flex column align-center">
              <h2>{{ $t('template.timeoutTitle') }}</h2>
              <p>{{ $t('template.timeoutBody') }}</p>
              <v-btn
                id="restartTimeout"
                depressed
                color="#0E5CF4"
                @click="timeoutRestart(false)"
                >{{ $t('template.timeoutButton') }}
              </v-btn>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </v-content>
  </v-app>
</template>

<script>
import shared from '../../utils/shared'
import TemplateDesktop from './template/templateDesktop'
import TemplateMobile from './template/templateMobile'
import TopContent from '../welcomeComponents/TopContent'

export default {
  components: {
    TemplateDesktop,
    TemplateMobile,
    TopContent,
  },
  props: {
    isTopContent: {
      default: true,
      type: Boolean,
    },
    valid: false,
    errorMessage: null,
    progress: null,
    section: null,
    submit: null,
    changedKey: null,
    noTitle: false,
    mainBackground: false,
    noTimout: false,
    showLogo: true,
    showBack: true,
    showTitle: true,
    showProgress: true,
  },
  data: () => ({
    initCustomerDetails: shared.initCustomerDetails,
    mobile: true,
    liliBrowser: false,
  }),
  computed: {
    shouldTitleDisplay() {
      return this.showTitle === undefined || this.showTitle
    },
    progressText() {
      if (this.section === '1') {
        return 'Contact'
      } else if (this.section === '2') {
        return 'Identity'
      } else if (this.section === '3') {
        return 'Address'
      } else if (this.section === '4') {
        return 'Occupation'
      } else if (this.section === '5') {
        return 'Confirmation'
      } else if (this.section === '6') {
        return 'Document Verification'
      } else if (this.section === '7') {
        return 'Authentication'
      }
      return 'About you'
    },
    timeoutDialog: {
      get: function () {
        return this.$store.state.timeout
      },
      set: function (newValue) {
        this.$store.state.timeout = false
      },
    },
  },
  mounted() {
    if (window.innerWidth > 700) {
      this.mobile = false
    } else {
      this.mobile = true
    }
    this.liliBrowser = shared.isInLiliApp()
  },
  methods: {
    timeoutRestart(value) {
      this.$store.state.timeout = false
      this.$store.state.restart = true
      if (!value) {
        this.$customerDetails = this.initCustomerDetails(this.$customerDetails)
        this.$router.push('/index.html')
        this.$store.state.restart = false
      }
    },
  },
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/shared/base-template.vue